// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	URL Transform Directive
	*/

	angular.module("swurveys.maker")
		.directive("promptInput", Handler)

	function Handler() {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModelController) {
				ngModelController.$parsers.push(function (data) {
					if(!data)
						return "";

					return data; //converted
				});

				ngModelController.$formatters.push(function (data) {

					if(!data)
						return "";

					// console.log(attrs.ngSrc);
					data = data.replace(/<[^>]+>/gm, '')

					// console.log(data);
					return data; //converted
				});
			}
		}
	}

}());
